import uuid from "react-uuid"

const correlationId = uuid();

export default correlationId;
